import { toValue, type MaybeRefOrGetter } from '@vueuse/core';
import { GIFT_CARD_TYPE } from '../../constants/giftcard';
import { useGiftBasicPreselect } from './useGiftBasicPreselect';
import { useGiftConsolidatedPreselect } from './useGiftConsolidatedPreselect';
import type { GIFT_CARD_FIELDS } from '../../types';

const picked = {
  [GIFT_CARD_TYPE.BASIC]: useGiftBasicPreselect,
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: useGiftConsolidatedPreselect,
  [GIFT_CARD_TYPE.E_GIFT_CARD]: useGiftBasicPreselect,
};

export const useGiftPreselect = (
  values: Partial<Record<GIFT_CARD_FIELDS, string>>,
  selectedGift: MaybeRefOrGetter<null | number | string>,
  giftCardType: MaybeRefOrGetter<GIFT_CARD_TYPE> = GIFT_CARD_TYPE.BASIC,
) => picked[toValue(giftCardType)](values, selectedGift);
